import React, { createContext, useContext, useState } from "react"

interface InviteContextProps {
  activePage: string
  setActivePage: (page: string) => void
  addInviteData: any
  setAddInviteData: (data: any) => void
  chooseTypeData: any
  setChooseTypeData: (data: any) => void
  addNamesData: any
  setAddNamesData: (data: any) => void
}

const InviteContext = createContext<InviteContextProps | undefined>(undefined)

export const InviteProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [activePage, setActivePage] = useState<string>("addInvitation")
  const [addInviteData, setAddInviteData] = useState<any>(null)
  const [chooseTypeData, setChooseTypeData] = useState<any>(null)
  const [addNamesData, setAddNamesData] = useState<any>(null)

  return (
    <InviteContext.Provider
      value={{
        activePage,
        setActivePage,
        addInviteData,
        setAddInviteData,
        chooseTypeData,
        setChooseTypeData,
        addNamesData,
        setAddNamesData,
      }}
    >
      {children}
    </InviteContext.Provider>
  )
}

export const useInviteContext = (): InviteContextProps => {
  const context = useContext(InviteContext)
  if (!context) {
    throw new Error("useInviteContext must be used within an InviteProvider")
  }
  return context
}
